<template>
<div class="hs-container">
    <el-radio-group v-model="query.is_read" @change="changeHandler">
        <el-radio-button label="0">未读消息</el-radio-button>
        <el-radio-button label="1">已读消息</el-radio-button>
    </el-radio-group>
    <div class="table">

        <el-table :data="messData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading" style="width: 100%">
            <el-table-column label="消息内容">
                <template slot-scope="scope">
                    <el-link @click="link(scope.row.route_path,scope.row.id)" type="primary">【{{scope.row.tag}}】{{scope.row.remark}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="from_user.realname" label="发送者">
            </el-table-column>

            <el-table-column prop="create_time" label="发起时间">
            </el-table-column>
            <el-table-column prop="is_read" label="是否处理" width="120">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.is_read==0" type="primary" @click="confirmButton(scope.row)">确定</el-button>
                    <el-tag v-else type="success">已读</el-tag>
                </template>

            </el-table-column>
        </el-table>
    </div>
    <!-- 底部操作栏 -->
    <div class="footer-box">
        <div class="download"></div>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagination.limit" :page-sizes="[15, 30, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="pagination.totals"></el-pagination>
        </div>
    </div>
</div>
</template>

<script>
const query = {
    is_read: 0

};
export default {
    namespaced: true,
    name: 'MessageCenter',
    data() {
        let tableHeight = window.innerHeight - 252;
        let windowheight = window.innerHeight;
        return {
            activeName: 'first',
            tableHeight: tableHeight,
            windowheight: windowheight,
            query: Object.assign({}, query), // 搜索条件
            currentPage: 1,
            pagination: {
                page: 1,
                limit: 15,
                totals: 1
            },
            loading: false,
            messData: [],
        };
    },
    created() {
        this.getTableData();
    },
    methods: {
        changeHandler(value) {
            this.query.status = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        //消息中心
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/notice/index';
            let query = {
                ...{
                    pagination: _this.pagination
                },
                ..._this.query
            };
            _this.$post(url, query).then(res => {
                if (res.code == 200) {
                    _this.messData = res.data.list;
                    _this.pagination = res.data.pagination;
                    _this.loading = false;
                }
            });

        },
        getMessage(id) {
            let _this = this;
            let urlLink = 'api/notice/hit';
            let query = {
                id: id
            };
            this.$post(urlLink, query).then(res => {
                if (res.code == '200') {

                } else {
                    _this.$message({
                        type: 'danger',
                        message: res.msg
                    });
                }
            })
        },
        confirmButton(row) {
            let _this = this;
            this.$confirm('确定已处理?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                _this.getMessage(row.id);
                _this.query.is_read = '1'
                _this.getTableData();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },
        link(url, id) {
            let _this = this;
            _this.$router.push({
                path: url
            });

        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
